import { style } from '@primeuix/styles/buttongroup';
import BaseStyle from '@primevue/core/base/style';

var classes = {
  root: 'p-buttongroup p-component'
};
var ButtonGroupStyle = BaseStyle.extend({
  name: 'buttongroup',
  style: style,
  classes: classes
});

export { ButtonGroupStyle as default };
//# sourceMappingURL=index.mjs.map
